import { any, z } from 'zod'
import { IMainComponentType as Type } from '../../enums'
import { checkAlphaNumerics } from 'src/utils/function'

export const mainComponentTypeSchema = z.object({
  label_en: z
    .string()
    .min(1)
    .refine(value => checkAlphaNumerics(value)),
  label_no: z
    .string()
    .min(1)
    .refine(value => checkAlphaNumerics(value)),
  componentType: z.number().optional().default(Type.Custom),
  customerId: z
    .number()
    .or(z.null())
    .or(z.string())
    .transform(value => {
      if (typeof value === 'string') return parseInt(value)
      if (typeof value === 'number') return value
      return null
    })
    .optional(),
  maxCountForCage: z
    .string()
    .min(1)
    .or(z.number())
    .transform(value => (typeof value == 'string' ? parseInt(value) : value))
    .refine(n => n > 0),
  customPropertyMainComponentTypes: z.array(any()).optional(),
  mainComponentTypeFormSchemas: z
    .array(
      z.object({
        formSchemaId: z.number(),
        movementTypes: z.array(z.number()),
      }),
    )
    .optional(),
})
